<template>
	<div>
		<el-button @click="btn.btnFun"><img style="width: 12px; height:12px;margin-right:5px" v-if="btn.btnIcon" :src="btn.btnIcon">{{btn.btnLabel}}</el-button>
	</div>
</template>
<script>
	export default {
		name: "btn",
		props: {
			btn: {
				type: Object,
				default: {}
			},
		},
		data: function() {
			return {}
		},
		/* computed: {
		}, */
		methods: {},
		mounted() {}
	};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/list/button/btn.vue